import {
  HrPermission,
  MODULE_PERMISSIONS,
  type HrPermissionCode,
} from '@/modules/Core/constants/hrPermissions'

export enum AdminRole {
  Admin = 'Admin',
  HrManager = 'HR Manager',
  Employee = 'Employee',
  Applicant = 'Applicant',
  SaleManager = 'SaleManager',
  SaleExpert = 'SaleExpert',
  AccountingManager = 'AccountingManager',
  AccountingExpert = 'AccountingExpert',
  WebsiteSupport = 'WebsiteSupport',
  CustomerSupport = 'CustomerSupport',
}

/** @deprecated Use permission checks instead */
export const FULL_ACCESS_ROLES: AdminRole[] = [
  AdminRole.Admin,
  AdminRole.HrManager,
]

export interface SidebarNavChild {
  title: string
  value: string
  link: string
  requiredPermissions?: readonly HrPermissionCode[]
}

export interface SidebarNavItem {
  title: string
  icon: string
  activeIcon: string
  value: string
  link?: string
  requiredPermissions: readonly HrPermissionCode[]
  children?: SidebarNavChild[]
}

export const SIDEBAR_NAV: SidebarNavItem[] = [
  {
    title: 'داشبورد',
    icon: 'gridSquare',
    activeIcon: 'gridSquareFill',
    value: 'dashboard',
    link: '/',
    requiredPermissions: MODULE_PERMISSIONS.dashboard,
  },
  {
    title: 'فرم استخدامی',
    icon: 'fileSearch',
    activeIcon: 'fileSearchFill',
    value: 'employmentForm',
    link: '/recruitment/employment-form',
    requiredPermissions: MODULE_PERMISSIONS.employmentForm,
  },
  {
    title: 'کارمندان',
    icon: 'users',
    activeIcon: 'usersFill',
    value: 'user',
    link: '/user',
    requiredPermissions: MODULE_PERMISSIONS.user,
  },
  {
    title: 'دبیرخانه',
    icon: 'secretariat',
    activeIcon: 'secretariatFill',
    value: 'secretariat',
    requiredPermissions: MODULE_PERMISSIONS.secretariatModule,
    children: [
      {
        title: 'ایجاد نامه',
        value: 'createLetter',
        link: '/secretariat/create',
        requiredPermissions: MODULE_PERMISSIONS.secretariatCreate,
      },
      {
        title: 'لیست نامه‌ها',
        value: 'letterList',
        link: '/secretariat',
        requiredPermissions: MODULE_PERMISSIONS.secretariatList,
      },
    ],
  },
  {
    title: 'چارت سازمانی',
    icon: 'orgChart',
    activeIcon: 'orgChartFill',
    value: 'orgChart',
    link: '/org-chart',
    requiredPermissions: MODULE_PERMISSIONS.orgChart,
  },
  {
    title: 'جذب و استخدام',
    icon: 'userViewfinder',
    activeIcon: 'userViewFill',
    value: 'recruitment',
    requiredPermissions: [
      HrPermission.EmployeeReadApplicant,
      HrPermission.FormReadAll,
      HrPermission.FormCreate,
      HrPermission.FormUpdate,
    ],
    children: [
      {
        title: 'فرم ساز',
        value: 'formBuilder',
        link: '/recruitment/form-builder',
        requiredPermissions: MODULE_PERMISSIONS.recruitmentFormList,
      },
      {
        title: 'متقاضیان',
        value: 'applicants',
        link: '/recruitment/applicants',
        requiredPermissions: MODULE_PERMISSIONS.recruitmentApplicants,
      },
    ],
  },
  {
    title: 'اطلاع رسانی و اخبار',
    icon: 'promotion',
    activeIcon: 'promotionFill',
    value: 'news',
    link: '/news',
    requiredPermissions: MODULE_PERMISSIONS.news,
  },
  {
    title: 'آموزش',
    icon: 'graduationCap',
    activeIcon: 'graduationCapFill',
    value: 'article',
    link: '/article',
    requiredPermissions: MODULE_PERMISSIONS.article,
  },
  {
    title: 'ارزشیابی',
    icon: 'fileSearch',
    activeIcon: 'fileSearchFill',
    value: 'evaluation',
    requiredPermissions: [
      HrPermission.FormReadAll,
      HrPermission.FormReadEvaluation,
      HrPermission.FormCreate,
      HrPermission.FormUpdate,
      HrPermission.FormSubmissionCreate,
      HrPermission.FormSubmissionReadOwn,
      HrPermission.FormSubmissionReadAll,
    ],
    children: [
      {
        title: 'ایجاد ارزشیابی',
        value: 'evaluationManage',
        link: '/evaluation',
        requiredPermissions: MODULE_PERMISSIONS.evaluation,
      },
      {
        title: 'ارزشیابی‌ها',
        value: 'evaluationAssigned',
        link: '/evaluation/assigned',
        requiredPermissions: MODULE_PERMISSIONS.evaluationAssigned,
      },
    ],
  },
  {
    title: 'یادآوری',
    icon: 'calendarClock',
    activeIcon: 'calendarClockFill',
    value: 'reminder',
    link: '/reminder',
    requiredPermissions: MODULE_PERMISSIONS.reminder,
  },
]

export const APPLICANT_LANDING_PATH = '/recruitment/employment-form'

export { MODULE_PERMISSIONS }
